import { render } from "./Edit.vue?vue&type=template&id=349530c8&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=349530c8&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349530c8"]])

export default __exports__